import type { FC } from 'react';
import React from 'react';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import {
    ASSET_NAME_CURRENCY,
    ASSET_NAME_FOND,
} from '@alfa-bank/site-invest-emitents-common/src/constants';

import type { TSector } from '../models';

export const SectorDesktop: FC<TSector> = ({ asset }) => {
    const { sectorName } = asset.issuer;
    const { assetType } = asset;
    const isSectorVisible =
        !!sectorName &&
        assetType.code !== ASSET_NAME_FOND &&
        assetType.code !== ASSET_NAME_CURRENCY;

    return isSectorVisible ? (
        <>
            <Text kind="secondary" styler={{ marginTop: 0, marginBottom: 8 }} view="primary-small">
                Сектор
            </Text>
            <Text styler={{ margin: 0 }} view="primary-large">
                {sectorName}
            </Text>
        </>
    ) : null;
};
